import { loanTypes } from '~/constants/loanTypes';

export const isNonDiJourney = (type) => type !== loanTypes.immediate && type !== loanTypes.refill;
